import {APIChannelService} from "../../config/axios-channel-service";
import axios from "axios";

const api = new APIChannelService();

export const CommonAPI = {
  getCurrentUser() {
    return api.get(`/api/v1/user/current-user`);
  },
  getAllChannelType() {
    return api.get(`/api/v1/channel-type`);
  },
  getChannelTierByType({ channelType, channelParent, channelManager }) {
    const url = `/api/v1/channel-tier/channel-type/${channelType}`;

    if (!!channelParent && !!channelManager) {
      return api.get(
        `${url}?parentTierId=${channelParent}&managerTierId=${channelManager}`
      );
    }

    return api.get(url);
  },

  getChannelManagerByParentName({ channelTierId, channelParentId }) {
    //channelTierId or channelTypeId
    return api.get(
      `/api/v1/channel-manager-config/${channelTierId}/channel-manager-tiers?channelParentId=${channelParentId}`
    );
  },
  getChannelManagerNameByParentName({ channelTierId, channelParentId }) {
    //channelTierId or channelTypeId
    return api.get(
      `/api/v1/channel/channel-tier/${channelTierId}?channelParentId=${channelParentId}`
    );
  },
  getChannelState() {
    return api.get(`/api/v1/channel-state`);
  },
  getTransactionStatus() {
    return api.get(`/api/v1/transaction-status`);
  },
  getChannelParentByTier(id) {
    return api.get(`/api/v1/commission-management/${id}/channel-parent-tiers`);
  },
  getChannelParent(channelTierId) {
    return api.get(
      `/api/v1/commission-management/${channelTierId}/channel-parent-tiers`
    );
  },
  getAllChannelPaperTypes() {
    return api.get(`/api/v1/channel/paper-types`);
  },
  getCountry() {
    return api.get("/api/v1/area/province");
  },
  getProvince() {
    return api.get("/api/v1/area/province");
  },
  getDistrict(provinceCode) {
    return api.get(`/api/v1/area/${provinceCode}/district`);
  },
  getPrecinct({ provinceCode, districtCode }) {
    return api.get(
      `/api/v1/area/${provinceCode}/district/${districtCode}/precinct`
    );
  },
  getBTS() {
    return api.get(`/api/v1/area/bts`);
  },
  getChildChannelParentOrManager(id) {
    return api.get(`/api/v1/channel/channel-tier/${id}`);
  },
  getParentChannelBySubType(id) {
    return api.get(`/api/v1/channel/parent/channel-tier/${id}`);
  },
  getChannelByType(channelTypeId) {
    const apiTmp =
      channelTypeId !== "ALL"
        ? api.get(
            `/api/v1/channel/user-channels?channelTypeId=${channelTypeId}`
          )
        : api.get(`/api/v1/channel/user-channels`);

    return apiTmp;
  },
  getOTP() {
    return api.get(`/api/v1/channel/otp/value`);
  },
  getConfig(typeConfig) {
    return api.get(`/public-api/v1/mobile/system-config?type=${typeConfig}`);
  },
  verifyOTP(otp) {
    return api.post(`/api/v1/channel/otp/verify/${otp}`);
  },
  verifyOTPChangePassword(payload) {
    return api.post(`/public-api/v1/sys-user/change-password`, payload);
  },
  downloadFile(id) {
    return api.postDownloadFile(`/api/v1/file-attach/download/${id}`);
  },
  getBankName() {
    return api.get(`/api/v1/bank`);
  },
  getBankAccountHO(bankCode) {
    return api.get(`/api/v1/trans-cash/ho-account-controls/${bankCode}`);
  },
  uploadFile(payload) {
    return api.postMultiForm("/api/v1/file-attach/simple-upload", payload);
  },
  updateFile({ id, rotate }) {
    return api.post(`/api/v1/file-attach/update/${id}?rotate=${rotate}`);
  },
  deleteFile(id) {
    return api.post(`/api/v1/file-attach/delete/${id}`);
  },
  channelConfig(channelTierId) {
    return api.get(`/api/v1/channel/channel-config/${channelTierId}`);
  },
  imageTypes() {
    return api.get(`/api/v1/file-attach/image-types`);
  },
  getChannelManagerTypeWithUser() {
    return api.get(`/api/v1/channel-type/user/manager`);
  },
  geolocation() {
    return axios.get("https://geolocation-db.com/json/");
  },
  getChannelBalance() {
    return api.get(`/api/v1/channel/channel-balance`);
  },
  getChannelTransaction(payload) {
    return api.post(`/api/v1/channel/channel-transaction`, payload);
  },
  getUserBank(channelCode = null) {
    const url = `/api/v1/channel/user-bank`;
    return api.get(!!channelCode ? `${url}?channelCode=${channelCode}` : url);
  },

  getAllChannelManager() {
    return api.get(`/api/v1/channel/withdraw-create/get-all-channel-manager`);
  },
  getChannelManagerWithdraw() {
    return api.get(`/api/v1/channel/withdraw-create/managers`);
  },
  getReceiverInfo() {
    return api.get(`/api/v1/channel/channel-info`);
  },
  getBusinessStaff() {
    return api.get(`/api/v1/channel/business-staff`);
  },
  getRequireBank(channelTierId) {
    return api.get(
      `/api/v1/channel/required-bank?channelTierId=${channelTierId}`
    );
  },
  getUserLanguage() {
    return api.get(`/public-api/v1/mobile/get-language-core`);
  },
  changeUserLanguage(payload) {
    return api.post(`/public-api/v1/mobile/change-language`, payload);
  },
};
